'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reset = require('../../redux/modules/reset');

var resetState = _interopRequireWildcard(_reset);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Reset = (_dec = (0, _reactRedux.connect)(function (state) {
  return { reset: state.reset.reset };
}, resetState), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Reset, _Component);

  function Reset() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Reset);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Reset.__proto__ || (0, _getPrototypeOf2.default)(Reset)).call.apply(_ref, [this].concat(args))), _this), _this.reset = function (evt) {
      evt.preventDefault();
      _this.props.resetState();
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Reset, [{
    key: 'render',
    value: function render() {
      var styles = require('./Reset.scss');
      var checkAnother = this.props.checkAnother;

      var content = null;

      if (checkAnother) {
        content = _react2.default.createElement(
          'p',
          null,
          'Check another booking, click ',
          _react2.default.createElement(
            'a',
            { href: '#', onClick: this.reset },
            'here'
          ),
          '.'
        );
      } else {
        content = _react2.default.createElement(
          'p',
          null,
          'Booking has been ended. Click ',
          _react2.default.createElement(
            'a',
            { href: '#', onClick: this.reset },
            'here'
          ),
          ' to reset.'
        );
      }

      return _react2.default.createElement(
        'div',
        { className: styles.reset + ' row' },
        _react2.default.createElement('div', { className: 'col-md-2' }),
        content
      );
    }
  }]);
  return Reset;
}(_react.Component), _class2.propTypes = {
  reset: _propTypes2.default.bool,
  resetState: _propTypes2.default.func,
  checkAnother: _propTypes2.default.bool
}, _temp2)) || _class);
exports.default = Reset;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Reset/Reset.js
// module id = 863
// module chunks = 0